
import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import { ProductSegmentModel } from '@/models/product_segment';
import { ProductSegmentList } from '@/collections/product_segments';

@Component({
  components: {
  },
})
export default class SegmentSelector extends Vue {
  public productSegments: ProductSegmentList = new ProductSegmentList();
  @Prop({ default: null })
  public initProductSegment!: ProductSegmentModel;
  @Prop({ default: null })
  public value!: ProductSegmentModel|null;
  public productSegment: ProductSegmentModel = new ProductSegmentModel();
  public segmentName: string = '';
  public selectingSegments: ProductSegmentList = new ProductSegmentList();
  public segmentMenu: boolean = false;
  @Prop({default: false})
  public disabled!: boolean;
  public keyword: string = '';
  public async created() {
   await this.loadProductSegments();
  }

  @Watch('value', { deep: true })
  private onValueChange(newValue: ProductSegmentModel | null) {
    if (!newValue || !newValue.id) {
      // Reset to empty segment when value is cleared
      this.productSegment = this.emptySegment;
      this.segmentName = this.emptySegment.name;
    } else {
      // Find the matching segment in the list
      const newValueId = newValue.id;
      const matchingSegment = this.selectingSegments.items.find(s => s.id === newValueId);
      if (matchingSegment) {
        this.productSegment = matchingSegment;
        this.segmentName = matchingSegment.name;
      }
    }
  }

  public async loadProductSegments() {
    await this.productSegments.fetch();
    this.selectingSegments.add(this.emptySegment);
    for (const segment of this.productSegments.items) {
      this.selectingSegments.add(segment);
    }
    
    // Initialize from value prop if provided
    if (this.value && this.value.id) {
      const valueId = this.value.id;
      const matchingSegment = this.selectingSegments.items.find(s => s.id === valueId);
      if (matchingSegment) {
        this.productSegment = matchingSegment;
        this.segmentName = matchingSegment.name;
      }
    } else if (this.initProductSegment && this.initProductSegment.id) {
      // Fallback to initProductSegment if value is not provided
      const initId = this.initProductSegment.id;
      const matchingSegment = this.selectingSegments.items.find(s => s.id === initId);
      if (matchingSegment) {
        this.productSegment = matchingSegment;
        this.segmentName = matchingSegment.name;
      }
    }
    
    // Default to empty segment if nothing is selected
    if (!this.productSegment.id) {
      this.productSegment = this.emptySegment;
      this.segmentName = this.emptySegment.name;
    }
  }

  public selectSegment() {
    this.segmentName = this.productSegment.name;
    this.segmentMenu = false;
    this.$emit('input', this.productSegment);
  }

  public get emptySegment() {
    const emptySegment = new ProductSegmentModel();
    emptySegment.name = 'All';
    return emptySegment;
  }
}
